import {type ReactNode, useReducer, type JSX} from 'react'
import {cloneDeep} from 'lodash'
import {DEFAULT_INCIDENTS_WIDGET_STATE} from './types/default-incidents-widget-state'
import {incidentsWidgetReducer} from './state/reducer'
import {type IncidentsWidgetState} from './types/incidents-widget-state'
import {IncidentsWidgetContext} from './incidents-widget-context'

type IncidentsWidgetProviderProps = {
    children: ReactNode
}

export function IncidentsWidgetProvider({children}: IncidentsWidgetProviderProps): JSX.Element {
    const initialState: IncidentsWidgetState = cloneDeep(DEFAULT_INCIDENTS_WIDGET_STATE)

    const [state, dispatch] = useReducer(incidentsWidgetReducer, initialState)

    return <IncidentsWidgetContext value={{state, dispatch}}>{children}</IncidentsWidgetContext>
}
